<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import PageHeader from "page-header";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  components: {
    PageHeader
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl
  },
  computed: {
    date() {
      return (new Date(this.content.activated_at)).toLocaleDateString(`${globalState.lang}-${globalState.lang.toUpperCase()}`, { day: "2-digit", month: "long", year: "numeric" });
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`,
        `text-${this.content.text_align}`
      ];
    },
    image() {
      if (this.content.image) {
        return this.getContentResponsiveImageURL('image').replace('/original/', '/medium/');
      } else {
        const backupImage = this.backupImage ? this.backupImage.url : false;
        if (backupImage) {
          return this.getBackgroundUrl(backupImage).replace('/original/', '/medium/');
        } else {
          return '';
        }
      }
    },
    backupImage() {
      return get(globalState.pageModel, ['layout', 'content', 'news_backup_image'], false)
    },
    topUrl() {
      const lastBreadcrumbItem = globalState.pageModel.breadcrumb[globalState.pageModel.breadcrumb.length - 1];
      if (lastBreadcrumbItem && lastBreadcrumbItem.slug) {
        return Fandom.applyContextToUrl(lastBreadcrumbItem.slug);
      } else {
        return Fandom.applyContextToUrl("/");
      }
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" class="position-relative pb-4" page-with-header-component page-news-component>
    <page-header :content="content"></page-header>
    <!-- image -->
    <div class="row mx-0 justify-content-center">
      <div class="col-lg-10 pb-4">
        <div class="ar-16by9 bg-cover-center" :style="{'background-image': image}"></div>
      </div>
    </div>
    <div class="container mt-4">
      <div class="row justify-content-center">
        <div :class="columnClasses">
          <small class="mb-0 text-gray-500 font-italic" v-if="content.activated_at">{{date}}</small>
        </div>
      </div>
    </div>
    <!-- optional stripes -->
    <component :is="stripe.layout" :content="stripe" v-for="stripe in content.stripes" :key="stripe.$id" :opt-container-content="containerContent"></component>
    <stripe-share :content="content.share":key="content.share.$id"v-if="content.share" :opt-container-content="containerContent"
    ></stripe-share>
    <div class="row mx-0 justify-content-center my-4">
      <div class="col-lg-10 text-center">
        <a class="btn btn-outline-dark" :href="topUrl">{{ft('globals.all_news')}}</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[page-news-component] {

  [stripe-info-box-component] {
    & > div {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }

  [text-section-component] {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .text-gray-500 {
    color: $gray-500;
  }
}
</style>